class Model {
  setDataForInstance (data, getterMethods) {
    var key
    for (key in data) {
      if (!getterMethods[key]) {
        this[key] = data[key]
      }
    }
    if (getterMethods) {
      for (key in getterMethods) {
        this[key] = getterMethods[key].apply(this)
      }
    } else {
      for (key in data) {
        this[key] = data[key]
      }
    }
  }
}

export default Model



// WEBPACK FOOTER //
// ./src/mods/model.js